/**
 * @file embedGuard.ts
 * @description Clickjacking guard (DL-523). Cloudflare Pages `_headers` match by path, not query string, so a
 * `frame-ancestors` header can't separate the public views from the Admin Portal / Ops Hub. Instead the SPA refuses to
 * render the non-public views when it is inside a frame. The public views were built to be embedded on client sites.
 */
import type { AppName } from './appUrl';

export const EMBEDDABLE_APPS: readonly AppName[] = ['tree', 'tag', 'apply', 'household'];

export function isFramed(): boolean {
	try {
		return window.self !== window.top;
	} catch {
		return true;
	}
}

/** `app` is null for `/auth/login` (admin / ops / provision sign-in), which is never embeddable. */
export function shouldBlockFrame(app: AppName | null): boolean {
	return isFramed() && !(app && EMBEDDABLE_APPS.includes(app));
}
